import { useContext } from 'react';
import { ModuleContext } from './ModuleContext';

export const useModule = () => useContext(ModuleContext);
